/**
 * Sessions UI store - manages dialog visibility state
 */
import { create } from 'zustand';

interface SessionsUIState {
  // State
  showSessionsDialog: boolean;
  /** True when dialog is opened at app startup, false when opened via toolbar */
  isStartupDialog: boolean;

  // Actions
  setShowSessionsDialog: (show: boolean) => void;
  /** Open dialog from startup flow */
  openSessionsDialogForStartup: () => void;
  /** Open dialog from toolbar button */
  openSessionsDialog: () => void;
  closeSessionsDialog: () => void;
}

export const useSessionsUIStore = create<SessionsUIState>((set) => ({
  // Initial state
  showSessionsDialog: false,
  isStartupDialog: false,

  // Actions
  setShowSessionsDialog: (show) => set({ showSessionsDialog: show }),
  openSessionsDialogForStartup: () => set({ showSessionsDialog: true, isStartupDialog: true }),
  openSessionsDialog: () => set({ showSessionsDialog: true, isStartupDialog: false }),
  closeSessionsDialog: () => set({ showSessionsDialog: false }),
}));
